(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trudoor-header"] && !Shopify.designMode) return;
  try {
    
  const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  };

  const getCookie = (name) => {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  const eraseCookie = (name) => {
    document.cookie = name + '=; Max-Age=-99999999;';
  };

  // const calcHeaderHeight = () => {
  //   const headerHeight = jQuery('#main-header').outerHeight();
  //   jQuery("body").css("padding-top", headerHeight);
  // }
  // calcHeaderHeight();

  const toggleSiteWideMessage = () => {
    const closed = getCookie('messageClosed');
    if (closed) {
      jQuery('.sitewide-message').hide();
    } else {
      jQuery('.sitewide-message').show();
      jQuery('.sitewide-message .close, .sitewide-message').on('click', function (e) {
        jQuery('.sitewide-message').hide();
        setCookie('messageClosed', 'closed', 1);
        // calcHeaderHeight();
      });
    }
    // calcHeaderHeight();
  };

  // jQuery(window).on('change DOMContentLoaded resize scroll', function () {
  //   setTimeout( calcHeaderHeight, 100);
  // });

  jQuery('.mobile-search').click(function () {
    jQuery('.header .lower-header form.search').toggleClass('open');
  });

  (function ($) {
    const disableParentLink = () => {
      let hasBeenRun = 0;
      $(document).on('touchend', '.menu-item-has-children a.toggle', function (e) {
        e.preventDefault();
        let thisLink = $(this),
          thisParentLi = $(this).parent(),
          thisSubMenu = $(this).parent().find('.sub-menu');

        if ($(e.target).parent().hasClass('open')) {
          thisParentLi.toggleClass('open');
          thisSubMenu.toggleClass('open');
        } else {
          $('.sub-menu').each(function (index) {
            if ($(this) !== thisSubMenu) $(this).removeClass('open');
          });
          $('.menu-item').each(function (index) {
            if ($(this) !== thisParentLi) $(this).removeClass('open');
          });
          $(this).parent().addClass('open');
          $(this).parent().find('.sub-menu').addClass('open');
        }
        if (hasBeenRun < 1) {
          hasBeenRun++;
          $('#menu-main-menu .menu-img').each(function () {
            const src = jQuery(this).attr('src'),
              dataSrc = jQuery(this).attr('data-src');
            if (src !== dataSrc) jQuery(this).attr('src', dataSrc);
          });
        }
      });
    };

    const hoverToToggle = () => {
      let hasBeenRun = 0;
      $('.menu-item-has-children.hover').mouseover(function () {
        $(this).addClass('open');
        $(this).find('.sub-menu').addClass('open');
        if (hasBeenRun < 1) {
          hasBeenRun++;
          $('#menu-main-menu .menu-img').each(function () {
            const src = jQuery(this).attr('src'),
              dataSrc = jQuery(this).attr('data-src');
            if (src !== dataSrc) jQuery(this).attr('src', dataSrc);
          });
        }
      });
      $('.menu-item-has-children.hover').mouseout(function () {
        $(this).removeClass('open');
        $(this).find('.sub-menu').removeClass('open');
      });
    };

    $(window).on('change load resize', function () {
      const windowidth = $(window).width();
      if (windowidth < 991 || window.is_device_key_valid) {
        $('.menu-toggle').click(function () {
          $('#main-header, body, .header, .header .main-nav').toggleClass('open');
          $(this).find('i').toggleClass('fa-times');
        });
        $('.menu-item-has-children > a.nav-link').addClass('toggle').removeClass('hover');
        disableParentLink();
      } else {
        $('#main-header, body, .header, .header .main-nav').removeClass('open');
        $('.menu-item-has-children').addClass('hover').removeClass('toggle');
        hoverToToggle();
      }
    });

    // const header = $('#main-header'),
    //   stickyTop = $('#main-header').offset().top + 0;
    // $(window).on('scroll', function () {
    //   if ($(window).scrollTop() > stickyTop) {
    //     header.addClass('sticky');
    //   } else {
    //     header.removeClass('sticky');
    //   }
    // });
  })(jQuery);

  } catch(e) { console.error(e); }
})();
})();
